import React from 'react';

import { MDBCard, MDBCardBody, MDBCardTitle, MDBModalHeader, MDBRow, MDBCol, MDBIcon, MDBInput, MDBModalBody, MDBModalFooter, MDBBtn, MDBModal } from 'mdbreact';

import DataLayer from '../Utilities/DataLayer';

import Header from './ComponentFragments/Header';

import Formatter from '../Utilities/Formatter';


export default class Inspire extends React.Component {

    constructor(props) {

        super(props);

        this.state = {

            transactionData: [],
            prevTrainingResult: '',
            currentQuestionId: 0,
            currentIndex: 0,
            currentQuestion: '',
            currentAnswerOptions: [],
            currentTypeOfDisplay: '',
            correctAnswerCount: 0,
            selectedAnswer: 0,
            userSeletedcorrectAnswerCounter: 0,
            answerList: [],
            tempCheckBoxAnswerCount: 0,
            balModalOpen: false,
            resultModalOpen: false,
            trainingCompletdModal: false,
            resultPercentage: 0,
            userTraining: {
                resultPercentage: 0,
                trainingId: 0
            },
            trainingStart: false
        }

        this.formatter = new Formatter();

        this.TMAUser = JSON.parse(localStorage.getItem("TMAUser"));


        this.getNextQuestionRadio = this.getNextQuestionRadio.bind(this);
        this.getNextQuestionCheckBox = this.getNextQuestionCheckBox.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleBackButton = this.handleBackButton.bind(this);
        this.modalStatusHandle = this.modalStatusHandle.bind(this);
        this.submitAnswersForm = this.submitAnswersForm.bind(this);
        this.endQuiz = this.endQuiz.bind(this);
        this.viewMedia = this.viewMedia.bind(this);
    }

    getNextQuestionRadio(theQuestionIndex) {

        let question = "";
        let answerOpt = [];
        let count = 0;
        let questionId = 0;

        if (this.state.selectedAnswer === 0) {

            this.setState({
                balModalOpen: true,
                // currentIndex: theIndex
            })
        } else if (this.state.currentIndex === this.state.transactionData.length - 1) {

            let result = this.state.userSeletedcorrectAnswerCounter * 20;

            this.setState({
                resultModalOpen: true,
                resultPercentage: result,
                userTraining: {
                    resultPercentage: result,
                    trainingId: 1
                }
            })
        } else {

            this.state.transactionData.map((nQuestion, index) => {

                if (index === theQuestionIndex) {

                    question = nQuestion.question_question;
                    questionId = nQuestion.questionid;
                    answerOpt = nQuestion.answers;

                    answerOpt.map(ourAnswer => {
                        if (ourAnswer.correctAnswer === 1) {
                            ++count;
                        }
                    })

                }

            })

            this.setState({

                currentQuestion: question,
                currentQuestionId: questionId,
                currentQuestionIndex: theQuestionIndex,
                currentAnswerOptions: answerOpt,
                correctAnswerCount: count,
                selectedAnswer: 0,
                currentIndex: theQuestionIndex,
            })
        }
    }

    handleBackButton(targetIndex) {

        let question = "";
        let answerOpt = [];
        let count = 0;
        let questionId = 0;
        let countCorrectAnswer = this.state.userSeletedcorrectAnswerCounter;

        this.state.transactionData.map((nQuestion, index) => {

            if (index === targetIndex) {

                question = nQuestion.question_question;
                questionId = nQuestion.questionid;
                answerOpt = nQuestion.answers;

                answerOpt.map(ourAnswer => {
                    if (ourAnswer.correctAnswer === 1) {
                        ++count;
                    }
                })

                --countCorrectAnswer;

            }

        })

        this.setState({

            currentQuestion: question,
            currentQuestionId: questionId,
            currentQuestionIndex: targetIndex,
            currentAnswerOptions: answerOpt,
            correctAnswerCount: count,
            selectedAnswer: 0,
            currentIndex: targetIndex,
            userSeletedcorrectAnswerCounter: countCorrectAnswer
        })

        // alert("Current index: " + targetIndex);
    }

    getNextQuestionCheckBox(theQuestionIndex) {

        let question = "";
        let answerOpt = [];
        let count = 0;
        let questionId = 0;
        let sum = 0;
        let countCorrectAnswer = this.state.userSeletedcorrectAnswerCounter;

        this.state.currentAnswerOptions.forEach(myFunction);

        function myFunction(item) {
            sum += item.correctAnswer;
        }

        if (sum === this.state.tempCheckBoxAnswerCount) {
            ++countCorrectAnswer;
        }

        if (this.state.answerList.length < 2) {
            this.setState({
                balModalOpen: true,
            })
        } else if (this.state.currentIndex === this.state.transactionData.length - 1) {

            let result = countCorrectAnswer * 20;

            this.setState({
                resultModalOpen: true,
                resultPercentage: result,
                userTraining: {
                    resultPercentage: result,
                    trainingId: 1
                }
            })

        } else {

            this.state.transactionData.map((nQuestion, index) => {

                if (index === theQuestionIndex) {

                    question = nQuestion.question_question;

                    questionId = nQuestion.questionid;
                    answerOpt = nQuestion.answers;

                    answerOpt.map(ourAnswer => {
                        if (ourAnswer.correctAnswer === 1) {
                            ++count;
                        }
                    })

                }

            })

            this.setState({

                currentQuestion: question,
                currentQuestionId: questionId,
                currentQuestionIndex: theQuestionIndex,
                currentIndex: theQuestionIndex,
                currentAnswerOptions: answerOpt,
                correctAnswerCount: count,
                userSeletedcorrectAnswerCounter: countCorrectAnswer,
                selectedAnswer: 0,
                tempCheckBoxAnswerCount: 0

            })

            // alert('Total correct from Box! ' + countCorrectAnswer);
        }

    }

    onClickRadio = (nr, answerSelect, questionId) => () => {
        let userAnswer = {
            userQuestionId: questionId,
            userAnswerId: nr
        }

        let countCorrectAnswer = this.state.userSeletedcorrectAnswerCounter;

        if (answerSelect === 1) {
            ++countCorrectAnswer;
        }

        this.setState({
            /*            userRadioAnswer: userAnswer,*/
            selectedAnswer: nr,
            userSeletedcorrectAnswerCounter: countCorrectAnswer,
        });

        // console.log(this.state.countCorrectAnswer);
    };

    onTrainingStart = () => () => {

        this.setState({
            trainingStart: true,
        })
    }

    allowRedoTraining = () => () => {
        this.setState({
            trainingCompletdModal: false
        })
    }

    startIgniteTraining = () => () => {
        const { history } = this.props;
        history.push('/salesforce/ignite')
    }


    handleChange(event, answerSelect, b) {

        // Destructuring
        const { value, checked } = event.target;

        let countCorrectAnswer = this.state.tempCheckBoxAnswerCount;
        // Case 1 : The user checks the box
        if (checked) {
            if (answerSelect === 1) {
                ++countCorrectAnswer;
            }

            this.setState({
                answerList: [...this.state.answerList, value]

            });
        }

        // Case 2  : The user unchecks the box
        else {
            if (answerSelect === 1) {
                --countCorrectAnswer;
            }

            this.setState({
                answerList: this.state.answerList.filter(
                    (e) => e !== value
                )
            });
        }

        this.setState({
            tempCheckBoxAnswerCount: countCorrectAnswer,
        });

        // alert(this.state.answerList.length + ' Is answer correct! ' + this.state.tempCheckBoxAnswerCount);
    };

    modalStatusHandle() {

        this.setState({
            balModalOpen: false,
        })
    }

    modalCompleteTrainingHandle() {
        alert("Modal Fire");
        this.setState({
            resultModalOpen: false
        })

        /*        const { history } = this.props;
                history.push('/salesforce')*/
    }

    async componentWillMount() {

        this.props.loaderOn();
        var dl = new DataLayer();

        let response = await dl.Get('/inspireandignite/gettrainingquestionnnaires/?trainingId=1');

        let correctAnswerCount = 0;

        let mark = false;

        if (typeof response.otherInfo !== 'undefined' && response.otherInfo !== null) {
            mark = true;
        }

        response.data[0].answers.map(ourAnswer => {
            if (ourAnswer.correctAnswer === 1) {
                ++correctAnswerCount;
            }
        })

        this.setState({

            transactionData: response.data,
            currentQuestion: response.data[0].question_question,
            currentQuestionId: response.data[0].questionid,
            currentAnswerOptions: response.data[0].answers,
            correctAnswerCount: correctAnswerCount,
            prevTrainingResult: response.otherInfo,
            trainingCompletdModal: mark
        });

        this.props.loaderOff();

    }

    async submitAnswersForm() {

        let requestObject = this.state.userTraining;

        var dl = new DataLayer();
        let result = await dl.Post('/inspireandignite/answers', this.state.userTraining);

        const { history } = this.props;
        history.push('/salesforce/ignite')
    }

    endQuiz() {
        this.setState({
            resultModalOpen: false
        })

        if (this.state.resultPercentage >= 80) {
            this.submitAnswersForm()
        } else {
            window.location.reload();
        }
    }

    viewMedia = (theMediaId, theFolder, theExtension) => {
        const { history } = this.props;
        history.push({
            pathname: '/salesforce/trainingmediaview',
            state: {
                mediaId: theMediaId,
                folder: theFolder,
                extension: theExtension,
                navigate: '/salesforce/inspire'
            }
        })
    }

    render() {

        let inspireHeader = 'Inspire Training Assessment';
        let igniteHeader = 'Ignite Training Assessment';
        const indexTotalQuestion = 9; // this.state.transactionData.length - 1

        const welcomeMessage = "Now that you’ve taken your first step to making a difference in your life and many other people’s lives, our training team together with our sales force will Inspire you through story telling to encourage you to be a successful Tupperware® member. We will support you with our free empowerment tools for your first 90 days to Ignite your new business and help you Grow up the Tupperware® Career path. Wishing you all the best in your first 90 days with us! Your success is our Goal.";

        return (

            <div>

                <Header headerText={this.state.trainingStart ? inspireHeader : 'Welcome to Inspire Training'} hideSearch={true} />

                <MDBRow>

                    {
                        !this.state.trainingStart && <MDBCol className="mb-r">

                            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>

                                <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>

                                    {welcomeMessage}

                                </MDBCardTitle>
                                <MDBCardBody>
                                    Step 1: Watch the Training Video

                                    <MDBBtn rounded color="purple" size="sm" onClick={() => this.viewMedia(701, "media", "mp4  ")}>Here</MDBBtn>

                                </MDBCardBody>
                                <MDBCardBody>
                                    Step 2: Complete The Inspire and Ignite Training Assessments and achieve a pass rate of 80% .
                                </MDBCardBody>
                                <MDBCardBody>
                                    Step 3: Get Active by placing an order to receive your New Confidence Kit.
                                </MDBCardBody>

                                <MDBCol style={{ textAlign: 'left' }}>
                                    {
                                        <MDBBtn onClick={this.onTrainingStart()}>Start Inspire Assessment</MDBBtn>
                                    }
                                </MDBCol>
                            </MDBCard>
                        </MDBCol>

                    }

                    {

                        this.state.trainingStart && <MDBCol className="mb-r">

                            <MDBCard className="card-body" style={{ marginTop: "1rem" }}>

                                <MDBCardTitle style={{ fontSize: "16px", paddingBottom: "3px" }}>

                                    {this.state.currentIndex <= indexTotalQuestion ? this.state.currentQuestion : 'Thank you very much for your time!'}

                                </MDBCardTitle>
                                <MDBCardBody>

                                    {

                                        this.state.currentAnswerOptions.map((theAnswer) => {
                                            return (this.state.correctAnswerCount === 1) ?
                                                < MDBInput key={theAnswer.mobiQuestionnaireAnswersId}
                                                    value={theAnswer.answer}

                                                    checked={this.state.selectedAnswer === theAnswer.mobiQuestionnaireAnswersId}

                                                    onClick={this.onClickRadio(theAnswer.mobiQuestionnaireAnswersId, theAnswer.correctAnswer
                                                        , this.state.currentQuestionId)}

                                                    label={theAnswer.answer}
                                                    type={this.state.correctAnswerCount > 1 ? "checkbox" : "radio"}
                                                    id={theAnswer.mobiQuestionnaireAnswersId}
                                                    containerClass="mr-5" />
                                                :
                                                < MDBInput key={theAnswer.mobiQuestionnaireAnswersId}
                                                    value={theAnswer.answer}

                                                    onChange={(e) => this.handleChange(e, theAnswer.correctAnswer,
                                                        this.state.currentQuestionId)}

                                                    label={theAnswer.answer}
                                                    type={this.state.correctAnswerCount > 1 ? "checkbox" : "radio"}
                                                    id={theAnswer.mobiQuestionnaireAnswersId}
                                                    containerClass="mr-5" />


                                        })
                                    }

                                </MDBCardBody>

                                {this.state.currentIndex <= indexTotalQuestion &&
                                    <MDBRow>
                                        <MDBCol>
                                            <MDBBtn type="submit" style={{ backgroundColor: "#7BD6DC" }}
                                                onClick={() => (this.state.correctAnswerCount === 1) ?
                                                    this.getNextQuestionRadio((1 + this.state.currentIndex))
                                                    :
                                                    this.getNextQuestionCheckBox((1 + this.state.currentIndex))
                                                }>

                                                {(this.state.currentIndex < this.state.transactionData.length - 1) ? 'Next' : 'Submit'}</MDBBtn>
                                        </MDBCol>
                                        <MDBCol style={{ textAlign: 'right' }}>
                                            {
                                                (this.state.currentIndex > 0) && <MDBBtn onClick={() => this.handleBackButton((--this.state.currentIndex))}>Back</MDBBtn>
                                            }
                                        </MDBCol>
                                    </MDBRow>
                                }

                            </MDBCard>

                        </MDBCol>
                    }

                </MDBRow>

                <MDBModal isOpen={this.state.balModalOpen} toggle={this.state.balModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "green" }}><MDBIcon fas icon="info" /></span>&nbsp;Select an answer!</MDBModalHeader>
                    <MDBModalBody>
                        {
                            (this.state.correctAnswerCount === 1) ?
                                "Please select atleast one answer!"
                                :
                                "Please select atleast two answers!"
                        }
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.modalStatusHandle()}>Ok</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.resultModalOpen} toggle={this.state.resultModalOpen} centered>
                    <MDBModalHeader><span style={{ color: "green" }}><MDBIcon fas icon="info" /></span>&nbsp;Your Results</MDBModalHeader>
                    <MDBModalBody>
                        {

                            (this.state.resultPercentage >= 80) ?
                                `Congratulations you have successfully passed by ${this.state.resultPercentage > 100 ? 100 : this.state.resultPercentage}%`
                                :
                                "Unfortunately you didn't meet the success mark yet. Please try again for 80% success rate."
                        }
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn rounded color="secondary" onClick={() => this.endQuiz()}>Ok</MDBBtn>

                    </MDBModalFooter>
                </MDBModal>

                <MDBModal isOpen={this.state.trainingCompletdModal} toggle={this.state.trainingCompletdModal} centered>
                    <MDBModalHeader><span style={{ color: "green" }}><MDBIcon fas icon="info" /></span>&nbsp;Training Completed</MDBModalHeader>
                    <MDBModalBody>
                        {
                           `Congratulations you have already successfully passed Inspire Training by ${this.state.prevTrainingResult}`
                        }
                    </MDBModalBody>
                    <MDBModalFooter>
                        <MDBBtn style={{ marginLeft: "-50px" }} rounded color="secondary"
                            onClick={

                                (typeof this.state.prevTrainingResult !== 'undefined' && this.state.prevTrainingResult !== null && this.state.prevTrainingResult.length > 5)
                                ?
                                    this.startIgniteTraining()
                                :
                                    this.allowRedoTraining()
                             }>Ok</MDBBtn>
                    </MDBModalFooter>
                </MDBModal>

            </div>

        );

    }

}